import { useIntl } from 'react-intl';
import { BadgeDV } from '../../BadgeDV/BadgeDV';

export const TipBadge = () => {
  const { formatMessage } = useIntl();

  return (
    <BadgeDV>
      {formatMessage({
        id: 'productAplus.tip',
        defaultMessage: 'Tipp',
      })}
    </BadgeDV>
  );
};
